<template>
  <div class="flex h-full">
    <h4 class="mr-8 flex items-center justify-center uppercase font-semibold">
      Accesos
    </h4>
    <router-link
      v-for="(menu, k) in options"
      v-bind:key="k"
      tag="span"
      :to="menu.path"
      class="
        cursor-pointer
        h-full
        p-2
        mx-2
        flex
        items-center
        justify-center
        -mb-2
      "
      exact-active-class="active"
      @click.native="$emit('clicked')"
    >
      <i :class="`el-icon-fa-${menu.icon} mr-2`"></i>
      {{ menu.name }}
    </router-link>
  </div>
</template>

<script>
import { checkPermissions } from "../../utils";

export default {
  name: "AccessSubMenu",
  data() {
    return {
      accessMenu: [
        //{
        //  icon: "check-square-o",
        //  path: "/access/profiles",
        //  name: "Perfiles",
        //},
        {
          icon: "user-o",
          path: "/access/users",
          name: "Usuarios",
          submodule: "Usuarios",
        },
      ],
    };
  },
  computed: {
    options() {
      return this.accessMenu.filter(
        (item) =>
          this.$store.getters.isSuper ||
          checkPermissions(`Accesos:${item.submodule}`, "Page:view") ||
          checkPermissions(`Accesos:${item.submodule}`, "Page:viewOwn")
      );
    },
  },
};
</script>
